import { useState } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import addSeconds from 'date-fns/addSeconds';
import { SECOND } from 'time-constants';
import { number, object, string } from 'yup';

import { apiConfig } from '@constants';

const refetchIntervalFallback = 900 * SECOND;

const activationDataSchema = object({
  device_code: string().required(),
  user_code: string().required(),
  verification_uri: string().required(),
  expires_in: number().required(),
  interval: number().required(),
  verification_uri_complete: string().required(),
});

const getDeviceActivation = async () => {
  // You MUST use append here for support on tizen!
  const payload = new URLSearchParams();

  payload.append('client_id', apiConfig.AUTH0_CLIENT_ID);
  payload.append('audience', apiConfig.DSP_HOST_URL);
  payload.append('scope', 'openid profile email');

  const { data } = await axios.post(apiConfig.AUTH0_DEVICE_CODE_URL, payload);
  const validData = await activationDataSchema.validate(data);

  return {
    ...validData,
    expirationTime: addSeconds(new Date(), data.expires_in),
  };
};

export const useGetAuth0DeviceActivation = (enabled: boolean) => {
  const [refetchInterval, setRefetchInterval] = useState(refetchIntervalFallback);

  return useQuery('getAuth0DeviceActivation', () => getDeviceActivation(), {
    enabled,
    refetchInterval,
    refetchOnWindowFocus: false,
    onSuccess: ({ expires_in }) => setRefetchInterval(expires_in * SECOND),
  });
};
